// @flow

import { type PaymentSpec, getCountry, getPaymentMethods } from '@tectonics/prs/payment-spec';
import { type PaymentMethodCode, getPaymentMethodCode } from '@tectonics/prs/payment-method';
import { type PrsSupport } from './types';
import { getSafeCountryIntegrations } from './get-integrations';

export function getSpecImplementedPaymentMethods(
  spec: PaymentSpec,
  support: PrsSupport,
): ImmutableArray<PaymentMethodCode> {
  const country = getCountry(spec);
  const specPaymentMethods = getPaymentMethods(spec);
  const prsIntegrations = getSafeCountryIntegrations(country, support);

  return prsIntegrations.filter(
    paymentMethodCode => specPaymentMethods.find(one => getPaymentMethodCode(one) === paymentMethodCode)
  );
}
